module.exports = __webpack_public_path__ + "static/media/Satoshi_Regular.71a6023c.woff2";